<template>
	<v-app
		:style="cssVars"
		v-if="$route.path.includes('/auth')"
		class="guest-layout-wrapper"
		style="display: flex"
	>
		<v-alert
			v-if="isShowAlert"
			absolute
			:type="alertType || 'success'"
			transition="scale-transition"
			class="app-alert"
			:dismissible="false"
		>
			{{ alertMessage }}

			<v-icon style="font-size: 20px" @click="closeAlert"> mdi-window-close</v-icon>
		</v-alert>
		<v-main class="wrapper">
			<div class="section-container">
				<div class="left-section">
					<img
						class="left-section"
						v-if="fullLogo"
						:src="fullLogo"
						alt="Logo"
						:class="logo ? 'logo-full-absolute' : 'logo-full'"
					/>
					<img v-if="logo" :src="logo" alt="Logo" class="logo-section" />
				</div>
				<div
					class="right-section"
					:style="{ backgroundColor: rightSideBarBackgroundColor }"
				>
					<slot></slot>
				</div>
			</div>
		</v-main>
	</v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isUndefined } from 'lodash'
import LoginIcon from '@/assets/images/img-login.svg'
import LocalStorageService from '@/services/local-storage.service'

export default {
	data: () => ({
		LoginIcon,
	}),
	methods: {
		...mapActions('app', ['hideAlert']),

		closeAlert() {
			clearTimeout(this.closeTimeout)
			this.hideAlert()
		},
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('settings', ['styles', 'login']),
		...mapGetters('app', ['isShowAlert', 'alertMessage', 'closeTimeout', 'alertType']),

		cssVars() {
			const {
				button_secondary_background: buttonSecondaryBgc,
				navigation_bar_tint: navigationBarTint,
				welcome_background: welcomeBackground,
				button_sign_up: buttonSignUpColor,
				button_login_background: buttonLoginBackground,
				button_login: buttonLoginColor,
				button_main_background: buttonMainBackground,
				button_main: buttonMainTextColor,
				text_button_tint: textButtonTint,
				link: linkColor,
				splash_screen_background: splashScreenBackground,
			} = this.styles || {}

			return {
				'--accent-color': navigationBarTint,

				'--login-background-color': '#ffffff',
				'--welcome-background-color': welcomeBackground,

				'--welcome-button-signup-color': buttonSignUpColor,
				'--welcome-button-login-background': buttonLoginBackground,
				'--welcome-button-login-color': buttonLoginColor,
				'--button_main_background': buttonMainBackground,
				'--button_main_text_color': buttonMainTextColor,
				'--text_button_tint': textButtonTint,
				'--link': linkColor,
				'--splash-screen-background': splashScreenBackground,
				'--button-secondary-background-color': buttonSecondaryBgc,
			}
		},
		rightSideBarBackgroundColor() {
			if (this.$route.name === 'welcome') {
				return this.cssVars['--welcome-background-color']
			}

			if (this.$route.name === 'login') {
				return this.cssVars['--login-background-color']
			}

			return '#ffffff'
		},
		fullLogo() {
			if (this.login) {
				return this.login.full_logo_x3
			}
			return null
		},
		logo() {
			if (this.login) {
				return this.login.logo_x3
			}
			return null
		},
		initRoute() {
			return LocalStorageService.get('initRoute') || null
		},
	},
	watch: {
		isAuthenticated(val, oldVal) {
			if (isUndefined(oldVal)) return
			if (val) {
				this.$router.push(this.initRoute ? this.initRoute : { name: 'threads' })
				LocalStorageService.remove('initRoute')
			}
		},
	},
}
</script>
<style lang="scss">
.section-container {
	display: grid;
	grid-template-columns: 424px 1fr;
	height: 100vh;
	@media (max-width: 780px) {
		grid-template-columns: 1fr;
	}
}

.left-section {
	max-width: 424px;
	background-color: var(--splash-screen-background);
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 780px) {
		display: none !important;
	}
}

.text-overlay {
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -50%);
	max-width: 470px;
	width: 100%;
	margin-bottom: 40px;
}

.text {
	color: rgb(255, 255, 255);
	font-size: 36px;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
}

.right-section {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

.logo {
	&-section {
		position: relative;
		width: 100%;
		max-height: 100vh;
		object-fit: cover;
	}

	&-full {
		object-fit: cover;
		max-height: 100vh;

		&-absolute {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
